module.exports = __webpack_public_path__ + "static/img/3.f4c5848.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20251009/3.jpg
// module id = Db8p
// module chunks = 7